<template>
    <div id="overview-container" @click="hideAllPic">
        <div class="show-pic-area" v-if="showTempArea">
            <div id="temp-area-show-pic"></div>
        </div>
        <div class="show-pic-area" v-if="showFanArea">
            <div id="fan-area-show-pic"></div>
        </div>
        <div id="middle-area">
            <div id="middle-top-area">
                <div class="device-overview shadow">
                    <div class="title">设备概览</div>
                    <div id="device-overview-info">
                        <div class="device-info">
                            <div class="device-info-title">设备总数</div>
                            <div class="device-info-info">{{ deviceNum }}</div>
                        </div>
                        <div class="device-info">
                            <div class="device-info-title">故障设备</div>
                            <div class="device-info-info">{{ badNum }}</div>
                        </div>
                        <div class="device-info">
                            <div class="device-info-title">推流中设备</div>
                            <div class="device-info-info">{{ streamNum }}</div>
                        </div>
                    </div>
                </div>
                <div class="down-device-area shadow">
                    <div class="title">故障设备列表</div>
                    <div id="down-device-info">
                        <div class="down-device-text">
                            机箱号
                        </div>
                        <div class="down-device-text">
                            槽位号
                        </div>
                        <div class="down-device-text">IP</div>
                    </div>
                    <div id="down-device-list">
                        <div id="down-device" v-for="dev in devList" :key="dev.id">
                            <div class="down-device-text">
                                {{ dev.caseNo }}
                            </div>
                            <div class="down-device-text">
                                {{ dev.slotNo }}
                            </div>
                            <div class="down-device-text">
                                {{ dev.deviceIp }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="server-info-area shadow">
                <el-scrollbar ref="scroll" :style="{height: getScrollHeight()}" :native="serverList.length <= 2"
                              v-if="serverList.length > 0">
                    <div class="server-info" v-for="(server,index) in serverList" v-if="serverList.length > 0">
                        <div class="server-info-item">
                            <div class="temp-show-area">
                                <div class="temp-title">设备{{index}}（{{server.deviceNo}}）</div>
                                <div class="temp-chart-area">
                                    <div class="temp-chart-show">
                                        <el-tooltip popper-class="tips" effect="light" placement="right">
                                            <div slot="content" class="temp-tooltip">
                                                <span v-if="server.netCardTemp > 60">网卡：<span style="color: red;">{{server.netCardTemp}}</span>℃</span>
                                                <span v-else>网卡：<span
                                                        style="color: green;">{{server.netCardTemp}}</span>℃</span>
                                                <span v-if="server.pmCardTemp > 60">管理卡：<span style="color: red;">{{server.pmCardTemp}}</span>℃</span>
                                                <span v-else>管理卡：<span
                                                        style="color: green;">{{server.pmCardTemp}}</span>℃</span>
                                                <span v-if="server.switchCardTemp > 60">交换卡：<span style="color: red;">{{server.switchCardTemp}}</span>℃</span>
                                                <span v-else>交换卡：<span
                                                        style="color: green;">{{server.switchCardTemp}}</span>℃</span>
                                                <span v-if="server.boardArea1 > 60">板卡区1：<span style="color: red;">{{server.boardArea1}}</span>℃</span>
                                                <span v-else>板卡区1：<span
                                                        style="color: green;">{{server.boardArea1}}</span>℃</span>
                                                <span v-if="server.boardArea2 > 60">板卡区2：<span style="color: red;">{{server.boardArea2}}</span>℃</span>
                                                <span v-else>板卡区2：<span
                                                        style="color: green;">{{server.boardArea2}}</span>℃</span>
                                                <span v-if="server.boardArea3 > 60">板卡区3：<span style="color: red;">{{server.boardArea3}}</span>℃</span>
                                                <span v-else>板卡区3：<span
                                                        style="color: green;">{{server.boardArea3}}</span>℃</span>
                                                <span v-if="server.boardArea4 > 60">板卡区4：<span style="color: red;">{{server.boardArea4}}</span>℃</span>
                                                <span v-else>板卡区4：<span
                                                        style="color: green;">{{server.boardArea4}}</span>℃</span>
                                            </div>
                                            <div :id="`temp-chart-${index}`"
                                                 style="width: 104px; height: 104px; position: relative;"></div>
                                        </el-tooltip>
                                    </div>
                                    <div class="temp-desc-area">
                                        <div class="temp-desc-tips">
                                            <label>温度区域</label>
                                            <el-tooltip effect="dark" content="点击查看示意图" placement="right">
                                                <div class="question-icon" @click="showTempAreaPic($event)">?</div>
                                            </el-tooltip>
                                        </div>

                                        <label style="font-weight: bold">异常提醒：</label>
                                        <label class="high-temp-area"
                                               v-if="highTempAreas[index] && highTempAreas[index].length > 0"><label
                                                style="color: red; ">{{highTempAreas[index]}}</label>温度过高，请检查</label>
                                        <label class="down-fan-area" v-else>无异常</label>
                                    </div>
                                </div>
                            </div>

                            <div class="fan-show-area">
                                <div class="fan-title">风扇位置</div>
                                <div class="fan-chart-area">
                                    <div class="fan-chart-show">
                                        <el-tooltip popper-class="tips" effect="light" placement="right">
                                            <div slot="content" class="fan-tooltip">
                                                <span v-if="server.fan1 === 0">Fan1：<span style="color: red;">{{server.fan1}}</span>rpm</span>
                                                <span v-else>Fan1：<span style="color: green;">{{server.fan1}}</span>rpm</span>
                                                <span v-if="server.fan2 === 0">Fan2：<span style="color: red;">{{server.fan2}}</span>rpm</span>
                                                <span v-else>Fan2：<span style="color: green;">{{server.fan2}}</span>rpm</span>
                                                <span v-if="server.fan3 === 0">Fan3：<span style="color: red;">{{server.fan3}}</span>rpm</span>
                                                <span v-else>Fan3：<span style="color: green;">{{server.fan3}}</span>rpm</span>
                                                <span v-if="server.fan4 === 0">Fan4：<span style="color: red;">{{server.fan4}}</span>rpm</span>
                                                <span v-else>Fan4：<span style="color: green;">{{server.fan4}}</span>rpm</span>
                                                <span v-if="server.fan5 === 0">Fan5：<span style="color: red;">{{server.fan5}}</span>rpm</span>
                                                <span v-else>Fan5：<span style="color: green;">{{server.fan5}}</span>rpm</span>
                                                <span v-if="server.fan6 === 0">Fan6：<span style="color: red;">{{server.fan6}}</span>rpm</span>
                                                <span v-else>Fan6：<span style="color: green;">{{server.fan6}}</span>rpm</span>
                                                <span v-if="server.fan7 === 0">Fan7：<span style="color: red;">{{server.fan7}}</span>rpm</span>
                                                <span v-else>Fan7：<span style="color: green;">{{server.fan7}}</span>rpm</span>
                                            </div>
                                            <div :id="`fan-chart-${index}`" style="width: 104px; height: 104px;">
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <div class="fan-desc-area">
                                        <div class="fan-desc-tips">
                                            <label>风扇位置</label>
                                            <el-tooltip effect="dark" content="点击查看示意图" placement="right">
                                                <div class="question-icon" @click="showFanAreaPic($event)">?</div>
                                            </el-tooltip>
                                        </div>

                                        <label style="font-weight: bold">异常提醒：</label>
                                        <label class="down-fan-area"
                                               v-if="downFanAreas[index] && downFanAreas[index].length > 0"><label
                                                style="color: red;">{{downFanAreas[index]}}</label>发生故障，请检查</label>
                                        <label class="down-fan-area" v-else>无异常</label>
                                    </div>
                                </div>
                            </div>
                            <!--{{server.deviceNo}}-->
                        </div>
                        <div class="my-line"></div>
                    </div>
                </el-scrollbar>
            </div>

            <div id="middle-bottom-area">
                <div class="license-area shadow">
                    <div class="title">License信息</div>
                    <div class="license-info" v-if="licenseInfo && licenseInfo.isNew">
                        <div class="info-view-main">
                            <div class="info-view-item">
                                <span>license码：</span>
                                <span style="max-width: 16em;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; ">{{licenseInfo.code}}</span>
                            </div>
                            <div class="info-view-item">
                                <span>在线服务：</span>
                                <span v-if="licenseInfo.isAuthenticate">已认证</span>
                                <span v-else>未认证</span>
                            </div>
                            <div class="info-view-item">
                                <span style="font-weight: bold">License信息：</span>
                            </div>
                            <div class="info-view-item">
                                <span style="font-weight: bold">永久设备总数：</span>
                                <span>{{licenseInfo.deviceNumForever}}台</span>
                            </div>

                            <div class="info-view-item-list">
                                <span style="font-weight: bold">有效期设备数量：</span>
                                <div v-for="notForeverItem in licenseInfo.deviceNotForever">
                                    <div class="device-notforever-item">
                                        <span>{{notForeverItem.total}}台</span>
                                        <span style="margin-left: 30px;">{{notForeverItem.seconds | secondsFilter}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="info-view-item-list">
                                <span style="font-weight: bold">永久配套服务信息：</span>
                                <div v-for="service in licenseInfo.serviceForever">
                                    <div class="service-item">
                                        <span>{{ serviceList[parseInt(service.serviceNo)]}}</span>
                                        <span v-if="service.serviceNo == 10"
                                              style="margin-left: 5px">-{{service.max}}</span>
                                        <span style="margin-left: 15px">{{service.total}}台</span>
                                    </div>
                                </div>
                            </div>
                            <div class="info-view-item-list">
                                <span style="font-weight: bold">有效期配套服务信息：</span>
                                <div v-for="service in licenseInfo.serviceNotForever">
                                    <div class="service-item">
                                        <span>{{ serviceList[parseInt(service.serviceNo)]}}</span>
                                        <span v-if="service.serviceNo == 10"
                                              style="margin-left: 5px">-{{service.max}}</span>
                                        <span style="margin-left: 15px">{{service.total}}台</span>
                                        <span style="margin-left: 15px">{{service.seconds | secondsFilter}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="license-info" v-else-if="licenseInfo">
                        <div class="license-info-first-line">
                            <div style="text-align: left; font-size:15px;width: 33%;">
                                有效时间：{{ licenseTime }}
                            </div>
                            <div style="width: 33%;text-align: left;">
                                在线认证：
                                <label v-if="licenseInfo.isAuthenticate">已认证</label>
                                <label v-else>未认证</label>
                                <label style="color:dodgerblue;margin-left:30px;" class="node" @click="authOnline()"
                                       v-if="!licenseInfo.isAuthenticate">在线认证</label>
                                <el-tooltip effect="dark" placement="right" v-if="!licenseInfo.isAuthenticate">
                                    <div slot="content">在线认证可获得什么？<br/>
                                        &nbsp;&nbsp;1.快速远程运维，一键提出问题，专人专员解决。<br/>
                                        &nbsp;&nbsp;2.后台升级包OTA推送，升级无忧。 <br/>
                                        &nbsp;&nbsp;3.设备故障提醒。
                                    </div>
                                    <div class="question-icon">?</div>
                                </el-tooltip>
                            </div>
                        </div>

                        <div class="license-info-text">
                            <div style="width: 33%">设备数量：{{licenseInfo.deviceNum }}</div>
                            <div style="width: 33%">预设虚拟化数量：{{containerNum}}</div>
                            <!--<div style="width: 33%" v-if="mirrorNum > 0">容器镜像数量：{{mirrorNum}}</div>-->
                        </div>
                        <div
                                class="license-info-text show-item"
                                style="margin-bottom: 5px;"
                        >
                            配套服务：
                        </div>
                        <div id="license-service-list" v-if="licenseInfo.service">
                            <div class="show-item-child" v-for="(item, index) in serviceList" v-if="item.length > 0">
                                {{ item
                                }}<i
                                    :class="[
                    checkLicenseService(index) === -1
                      ? 'el-icon-error'
                      : 'el-icon-success'
                  ]"
                                    :style="{
                    color:
                      checkLicenseService(index) === -1
                        ? 'red'
                        : 'green'
                  }"
                            ></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="disk-space shadow">
                    <div class="title">服务器存储空间</div>
                    <div id="diskSpace" style="width: 100%;height: 100%; margin-top: 10px;"></div>
                </div>
            </div>
        </div>
        <div id="right-area">
            <div class="right-side-area shadow">
                <div class="title">常见问题：</div>
                <div class="right-side-info">
                    <el-button
                            type="text"
                            style="text-align: left;margin-left: 0"
                            @click="$router.push('/home/help/faq')"
                    >1.如何安装应用
                    </el-button
                    >
                    <el-button
                            type="text"
                            style="text-align: left;margin-left: 0"
                            @click="$router.push('/home/help/faq')"
                    >2.如何配置网管
                    </el-button
                    >
                </div>
            </div>
            <div class="right-side-area shadow">
                <div class="title">常用入口</div>
                <div id="useful-entry-list">
                    <div
                            v-for="page in normalPages"
                            :key="page.path + '-normal'"
                            @click="$router.push(page.path)"
                            class="node"
                    >
                        {{ page.name }}
                    </div>
                </div>
            </div>
            <div class="right-side-area shadow">
                <div class="title">最近访问</div>
                <div id="recently-entry-list">
                    <div v-for="page in latelyPages" :key="page.path + '-lately'" @click="$router.push(page.path)"
                         class="node">{{page.name}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    let that;
    var valObj = {min: 0, mid: 50, max: 60};//自定义区间值
    var colorObj = {min: '#01AAED', safe: '#5FB878', warn: '#FF5722', max: '#FF0000'};//颜色对应以上区间值定义
    // var percent = (Math.random() * 100).toFixed(2) - 0;//获取100以内的随机模拟数据
    var percent;
    var pieChart = [];
    var gaugeChart = [];
    var maxVal = 125;//圆环极大值

    export default {
        name: "Overview",
        data() {
            return {
                refreshChartsTimer: null,
                serviceList: ['命令转发', 'IP代理', '设备大师', '虚拟定位', 'ADB调试', '远程虚拟相机', '多开远程控制窗口', '电商推流直播', '音视频导入云机', '', '虚拟化容器', '', '', '', '', '', '', '', '', '', '后台安全认证', '音视频定点播放', '守护大师', '', '', '', '', '', '', '', '镜像备份'],
                deviceNum: 0,
                badNum: 0,
                streamNum: 0,
                normalPages: [],
                latelyPages: [],
                serverList: [],
                highestTempValue: 0,
                highTempAreas: [],
                lowestFanValue: 0,
                downFanAreas: [],
                licenseInfo: null,
                devList: [],
                containerNum: 0,
                mirrorNum: 0,
                showTempArea: false,
                showFanArea: false,
                mouseX: 0,
                mouseY: 0
            };
        },
        computed: {
            licenseTime() {
                let s = this.licenseInfo.secondsLeft;
                if (s === -1) {
                    return "永久";
                }
                else if (s === 0) {
                    return "0"
                }
                let time = "";
                let day = parseInt(s / (60 * 60 * 24));
                if (day > 0) {
                    time += day + "天";
                }
                s = s - day * (60 * 60 * 24);
                let hour = parseInt(s / (60 * 60));
                if (hour > 0) {
                    time += hour + "小时";
                }
                return time;
            }
        },
        filters: {
            secondsFilter(s) {
                if (s === -1) {
                    return '永久'
                } else if (s === 0) {
                    return "到期"
                }
                let time = ''
                let day = parseInt(s / (60 * 60 * 24))
                if (day > 0) {
                    time += day + '天'
                }
                s = s - day * (60 * 60 * 24)
                let hour = parseInt(s / (60 * 60))
                if (hour > 0) {
                    time += hour + '小时'
                }
                return time
            },
        },
        methods: {
            checkLicenseService(index) {
                let found = -1
                if (this.licenseInfo && this.licenseInfo.service) {
                    let serviceItems = this.licenseInfo.service.toString().split(",")
                    serviceItems.forEach(item => {
                        // console.log("item is " + item + ", index is " + index)
                        if (item == index) {
                            found = 1
                            return
                        }
                    })
                }
                return found
            },
            getLicense() {
                let licenseNew = {}
                this.$post(this.$uri.system.licenseGet).then(res => {
                    if (res.success) {
                        console.log("license is ")
                        console.log(res.data)
                        licenseNew = res.data
                        if (licenseNew.hasOwnProperty("isNew") && licenseNew.isNew == 1) {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)
                            }

                            if (licenseNew.service) {
                                let serviceItems = licenseNew.service.toString().split(",")
                                // console.log("serviceItems is " + serviceItems)
                                serviceItems.forEach(item => {
                                    if (item == 0) {
                                        this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                    } else if (item == 1) {
                                        this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                    } else if (item == 2) {
                                        this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                    } else if (item == 30) {
                                        this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                    }
                                })
                            }
                        } else {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)

                                this.mirrorNum = 0
                                this.containerNum = 0
                                if (licenseNew.service) {
                                    let serviceItems = licenseNew.service.toString().split(",")
                                    // console.log("serviceItems is " + serviceItems)
                                    serviceItems.forEach(item => {
                                        // console.log("item is " + item)
                                        if (item == 0) {
                                            this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                        } else if (item == 1) {
                                            this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                        } else if (item == 2) {
                                            this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                        } else if (item == 10) {
                                            this.containerNum = 1
                                        } else if (item == 11) {
                                            this.containerNum = 2
                                        } else if (item == 12) {
                                            this.containerNum = 3
                                        } else if (item == 30) {
                                            this.mirrorNum = 3
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        } else if (item == 31) {
                                            this.mirrorNum = 5
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        }
                                    })
                                }
                            }
                        }
                        this.$store.commit(this.$mutation.LICENSE_SAVE, licenseNew)
                        this.$store.commit(this.$mutation.ENABLE_PHONE_MODEL)

                        // console.log("licenseInfo is " + JSON.stringify(licenseNew))
                        this.licenseInfo = JSON.parse(JSON.stringify(licenseNew))
                        this.checkLicenseExpire(this.licenseInfo)
                    }
                })
            },
            checkLicenseExpire(licenseInfo) {
                if (licenseInfo.hasOwnProperty("isNew") && licenseInfo.isNew == 1) {
                    if (licenseInfo.deviceNotForever.total > 0 && licenseInfo.deviceNotForever.seconds < 3600 * 24 * 7) {
                        let msg = ""
                        if (licenseInfo.deviceNotForever.seconds > 0) {
                            msg = '您有 ' + licenseInfo.deviceNotForever.total + ' 台有效期设备将于' + parseInt(licenseInfo.deviceNotForever.seconds / (3600 * 24)) + '天后到期，请支付尾款后联系运维人员获取新的设备认证信息'
                        } else {
                            msg = '您有 ' + licenseInfo.deviceNotForever.total + ' 台有效期设备已到期，请支付尾款后联系运维人员获取新的设备认证信息'
                        }
                        setTimeout(() => {
                            this.$message({
                                showClose: true,
                                message: msg,
                                type: 'warning',
                                duration: 5000
                            });
                        }, 10)
                    }
                    licenseInfo.serviceNotForever.forEach(service => {
                        // console.log("service is " + JSON.stringify(service))
                        if (service.total > 0 && service.seconds < 3600 * 24 * 7) {
                            let msg = ""
                            if (service.seconds > 0) {
                                msg = '您的测试配套服务： ' + this.serviceList[parseInt(service.serviceNo)] + ' 将于' + parseInt(service.seconds / (3600 * 24)) + '天后到期，如需购买请联系运维人员'
                            } else {
                                msg = '您的测试配套服务： ' + this.serviceList[parseInt(service.serviceNo)] + ' 已经到期，如需购买请联系运维人员'
                            }
                            setTimeout(() => {
                                this.$message({
                                    showClose: true,
                                    message: msg,
                                    type: 'warning',
                                    duration: 5000,
                                    center: true
                                });
                            }, 10)
                        }
                    })
                }
            },
            authOnline() {
                // console.log("auth online ")
                this.$post(this.$uri.system.licenseOnLine).then(res => {
                    if (res.success) {
                        this.getLicense()
                    }
                })
            },

            getScrollHeight() {
                if (this.serverList.length > 2) {
                    return "100%";
                } else {
                    return "auto";
                }
            },
            showTempAreaPic(ev) {
                // console.log("show tempAreaPic")
                ev.cancelBubble = true
                this.showTempArea = !this.showTempArea
            },
            showFanAreaPic(ev) {
                // console.log("show fanAreaPic")
                ev.cancelBubble = true
                this.showFanArea = !this.showFanArea
            },
            hideAllPic() {
                this.showTempArea = false
                this.showFanArea = false
            },
            getArmSrvList() {
                this.$post(this.$uri.device.getManageDeviceInfo).then(res => {
                    if (res.success) {
                        var listTmp = res.list
                        if (listTmp.length > 0) {
                            // that.serverList = res.list;
                            this.serverList = JSON.parse(JSON.stringify(this.formatServerList(listTmp)))
                            // console.log("serverList is " + JSON.stringify( this.serverList));
                            // if (this.serverList.length > 0) {
                            //     this.showChartsNow = true;
                            // } else {
                            //     this.showChartsNow = false;
                            // }
                            if (this.serverList.length <= 2 && this.serverList.length > 0) {
                                // console.log("1111111111111111111111")
                                if (this.$refs.scroll) {
                                    var scroller = this.$refs.scroll.wrap;
                                    scroller.style = 'overflow-y: hidden;'
                                }
                                // var serverAreaDom = this.$refs.serverArea
                            }
                            this.$nextTick(() => {
                                for (var i = 0; i < this.serverList.length; i++) {
                                    // console.log("show chart now " + i)
                                    this.showTempChart(i)
                                    this.showFanChart(i)
                                }
                            })
                            // console.log("this.serverList.length is " + this.serverList.length);
                        }
                    }
                })
            },
            formatServerList(list) {
                var newList = [];
                for (var i = 0; i < list.length; i++) {
                    var item = list[i];
                    var newItem = {};
                    newItem.deviceIp = item.deviceIp;
                    newItem.deviceNo = item.deviceNo;
                    newItem.netCardTemp = parseInt(item.netCardTemp);
                    newItem.pmCardTemp = parseInt(item.pmCardTemp);
                    newItem.switchCardTemp = parseInt(item.switchCardTemp);
                    newItem.boardArea1 = parseInt(item.boardArea1);
                    newItem.boardArea2 = parseInt(item.boardArea2);
                    newItem.boardArea3 = parseInt(item.boardArea3);
                    newItem.boardArea4 = parseInt(item.boardArea4);
                    newItem.fan1 = parseInt(item.fan1);
                    newItem.fan2 = parseInt(item.fan2);
                    newItem.fan3 = parseInt(item.fan3);
                    newItem.fan4 = parseInt(item.fan4);
                    newItem.fan5 = parseInt(item.fan5);
                    newItem.fan6 = parseInt(item.fan6);
                    newItem.fan7 = parseInt(item.fan7);
                    newList.push(newItem);
                }
                // console.log("newList is " + JSON.stringify(newList))
                return newList;
            },
            changeColor(percent) {
                var color;
                if (percent < valObj.min) {
                    color = colorObj.min;
                } else if (percent >= valObj.min && percent <= valObj.mid) {
                    color = colorObj.safe;
                } else if (percent >= valObj.mid && percent <= valObj.max) {
                    color = colorObj.warn;
                } else {
                    color = colorObj.max;
                }
                return color;
            },
            showTempChart(id) {
                pieChart[id] = this.$echarts.init(document.getElementById('temp-chart-' + id));
                var pieChartOption = {
                    title: {
                        text: '温度',//圆环中间显示的数值单位
                        // lineHeight: 160,
                        // left:'center',
                        // verticalAlign: 'top',
                        // subtext: '',//圆环数值单位下面的描述文字
                        subtext: '{a|温度：}{b|单位}',
                        x: 'center',
                        y: '30',
                        //  textAlign:'center',
                        itemGap: 5,//描述文字与上面数值单位的垂直距离
                        textStyle: {
                            color: 'rgba(55,55,55,0.6)',
                            fontSize: 12,
                        },
                        subtextStyle: {
                            rich: {
                                a: { //开头和结尾的文字样式
                                    color: 'rgba(0,0,0,0.8)',
                                    fontSize: 18,
                                    fontWeight: 'bold',//字体加粗
                                },
                                b: {
                                    color: 'rgba(0,0,0,0.8)',
                                    fontSize: 10,
                                }
                            }
                        }
                    },
                    // animation: false,
                    tooltip: {         // 提示框. Can be overwrited by series or data
                        show: false,
                        trigger: 'axis',
                        // triggerOn: 'mousemove',
                        // enterable:true,//鼠标是否可进入提示框浮层中
                        // position: 'inside',
                        confine: true,//显示不会超出范围
                        backgroundColor: 'rgba(255,255,255,1)',
                        textStyle: {
                            fontSize: 10,
                            align: 'left',
                            color: 'black'
                        },
                        formatter: function () {
                            var res = '';
                            var myseries = pieChartOption.series;
                            for (var i = 0; i < myseries.length; i++) {
                                for (let j = 0; j < myseries[i].data2.length; j++) {
                                    if (myseries[i].data2[j].value > 60) {
                                        res += myseries[i].data2[j].name + ' : ' + '<span style="color:red;">' + myseries[i].data2[j].value + '℃</span></br>';
                                    } else {
                                        res += myseries[i].data2[j].name + ' : ' + '<span style="color:green;">' + myseries[i].data2[j].value + '℃</span></br>';
                                    }
                                }
                            }
                            return res;
                        }
                    },
                    series: [
                        {
                            name: '温度',
                            type: 'pie',
                            radius: ['88%', '100%'],//饼图的内、外半径
                            hoverAnimation: false,
                            label: {
                                normal: {
                                    show: false,
                                }
                            },
                            data: [{//系列中的数据内容数组
                                value: percent,
                                itemStyle: {
                                    normal: {
                                        color: this.changeColor(percent)
                                    }
                                }
                            }, {
                                value: maxVal - percent,
                                itemStyle: {
                                    normal: {
                                        color: '#cae1ff'
                                    },
                                    emphasis: {
                                        color: '#cae1ff'
                                    }
                                }
                            }
                            ],
                            data2: [
                                {name: '管理卡', value: 0, itemStyle: null},
                                {name: '网卡', value: 0, itemStyle: null},
                                {name: '交换卡', value: 0, itemStyle: null},
                                {name: '板卡区1', value: 0, itemStyle: null},
                                {name: '板卡区2', value: 0, itemStyle: null},
                                {name: '板卡区3', value: 0, itemStyle: null},
                                {name: '板卡区4', value: 0, itemStyle: null},
                            ],
                        }
                    ]
                };
                // var randomVal = (Math.random() * 100).toFixed(0) - 0;//模拟数据
                pieChartOption.series[0].data2[0].value = parseInt(this.serverList[id].pmCardTemp)
                pieChartOption.series[0].data2[1].value = parseInt(this.serverList[id].netCardTemp)
                pieChartOption.series[0].data2[2].value = parseInt(this.serverList[id].switchCardTemp)
                pieChartOption.series[0].data2[3].value = parseInt(this.serverList[id].boardArea1)
                pieChartOption.series[0].data2[4].value = parseInt(this.serverList[id].boardArea2)
                pieChartOption.series[0].data2[5].value = parseInt(this.serverList[id].boardArea3)
                pieChartOption.series[0].data2[6].value = parseInt(this.serverList[id].boardArea4)
                var highestTemp = this.findHighTemp(pieChartOption.series[0].data2, id)
                // console.log('highestTemp is ' + highestTemp)
                pieChartOption.title.subtext = '{a|' + `${highestTemp}` + '}' + '{b|℃}';//圆环中间显示的数值单位
                pieChartOption.series[0].data[0].value = highestTemp;//定时更新数值
                pieChartOption.series[0].data[1].value = (maxVal - highestTemp).toFixed(2) - 0;//圆环无颜色填充区域占比
                pieChartOption.series[0].data[0].itemStyle.normal.color = this.changeColor(highestTemp);//根据数值改变颜色
                // pieChartOption.series[0].data[1].itemStyle.normal.color = changecolor(maxVal - randomVal);//根据数值改变颜色
                pieChart[id].setOption(pieChartOption);
            },
            showFanChart(id) {
                gaugeChart[id] = this.$echarts.init(document.getElementById('fan-chart-' + id));

                var gaugeChartOption = {
                    title: {},
                    tooltip: {         // 提示框. Can be overwrited by series or data
                        show: false,
                        trigger: 'item',
                        confine: true,
                        backgroundColor: 'rgba(255,255,255,1)',
                        textStyle: {
                            align: 'left',
                            color: 'black',
                            fontSize: 10,
                        },
                        formatter: function (params) {
                            var res = '';
                            var myseries = gaugeChartOption.series;
                            for (var i = 0; i < myseries.length; i++) {
                                for (let j = 0; j < myseries[i].data2.length; j++) {
                                    if (myseries[i].data2[j].value === 0) {
                                        res += myseries[i].data2[j].name + ' : ' + '<span style="color:red;">' + myseries[i].data2[j].value + '</span>' + '<span>rpm</span></br>';
                                    } else {
                                        res += myseries[i].data2[j].name + ' : ' + '<span style="color:green;">' + myseries[i].data2[j].value + '</span>' + '<span>rpm</span></br>';
                                    }
                                }
                            }
                            return res;
                        }
                    },
                    series: [
                        {
                            name: '风扇转速',
                            type: 'gauge',
                            center: ['50%', '50%'],
                            z: 3,
                            min: 0,
                            max: 13200,
                            splitNumber: 1,
                            radius: '100%',
                            axisLine: {            // 坐标轴线
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    width: 6
                                }
                            },
                            axisTick: {            // 坐标轴小标记
                                length: 10,        // 属性length控制线长
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    color: 'auto'
                                }
                            },
                            splitLine: {           // 分隔线
                                length: 10,         // 属性length控制线长
                                lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                    color: 'auto'
                                }
                            },
                            pointer: {
                                width: 2
                            },
                            title: {
                                textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                    fontWeight: 'normal',
                                    fontSize: 10,
                                    color: 'rgba(55,55,55,0.6)',
                                }
                            },
                            detail: {
                                offsetCenter: [0, "80%"],
                                textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                                    fontWeight: 'normal',
                                    fontSize: 20
                                }
                            },
                            data: [{value: 4, name: '风扇转速'}],
                            data2: [{name: 'Fan1', value: 0, itemStyle: null},
                                {name: 'Fan2', value: 0, itemStyle: null},
                                {name: 'Fan3', value: 0, itemStyle: null},
                                {name: 'Fan4', value: 0, itemStyle: null},
                                {name: 'Fan5', value: 0, itemStyle: null},
                                {name: 'Fan6', value: 0, itemStyle: null},
                                {name: 'Fan7', value: 0, itemStyle: null},]
                        }
                    ]
                };
                gaugeChartOption.series[0].data2[0].value = parseInt(this.serverList[id].fan1)
                gaugeChartOption.series[0].data2[1].value = parseInt(this.serverList[id].fan2)
                gaugeChartOption.series[0].data2[2].value = parseInt(this.serverList[id].fan3)
                gaugeChartOption.series[0].data2[3].value = parseInt(this.serverList[id].fan4)
                gaugeChartOption.series[0].data2[4].value = parseInt(this.serverList[id].fan5)
                gaugeChartOption.series[0].data2[5].value = parseInt(this.serverList[id].fan6)
                gaugeChartOption.series[0].data2[6].value = parseInt(this.serverList[id].fan7)
                var lowestFan = this.findDownFan(gaugeChartOption.series[0].data2, id)
                gaugeChartOption.series[0].data[0].value = lowestFan
                // gaugeChartOption.series[0].data[1].value = (maxVal - highestTemp).toFixed(2) - 0;//圆环无颜色填充区域占比
                // gaugeChartOption.series[0].data[0].itemStyle.normal.color = this.changeColor(highestTemp);//根据数值改变颜色
                // pieChartOption.series[0].data[1].itemStyle.normal.color = changecolor(maxVal - randomVal);//根据数值改变颜色
                gaugeChart[id].setOption(gaugeChartOption)
            },
            findHighTemp(tempArray, id) {
                var highest = 0
                this.highTempAreas[id] = ''
                for (let i = 0; i < tempArray.length; i++) {
                    highest = (tempArray[i].value > highest) ? tempArray[i].value : highest
                    if (tempArray[i].value > 60) {
                        // console.log('>>' + tempArray[i].name + ':' + tempArray[i].value)
                        if (this.highTempAreas[id].length > 0) {
                            this.highTempAreas[id] += '、'
                        }
                        this.highTempAreas[id] += tempArray[i].name
                    }
                }
                return highest
            },
            findDownFan(fanArray, id) {
                var lowest = 99999
                this.downFanAreas[id] = ''
                for (let i = 0; i < fanArray.length; i++) {
                    lowest = fanArray[i].value < lowest ? fanArray[i].value : lowest
                    if (fanArray[i].value === 0) {
                        if (this.downFanAreas[id].length > 0) {
                            this.downFanAreas[id] += '、'
                        }
                        this.downFanAreas[id] += fanArray[i].name
                    }
                }
                return lowest
            },
            getDiskSpace() {
                this.$post(this.$uri.system.diskSpace).then(res => {
                    // console.log("getDiskSpace res is " + JSON.stringify(res))
                    if (res.success) {
                        // console.log('echarts')
                        const myChart = this.$echarts.init(document.querySelector('#diskSpace'))

                        let all = res.data.usedSpace / 1024 / 1024 / 1024 + ''
                        // all = all.substring(0, all.indexOf('.') + 2)
                        all = parseFloat(all).toFixed(2)
                        let last = res.data.freeSpace / 1024 / 1024 / 1024 + ''
                        // last = last.substring(0, last.indexOf('.') + 2)
                        last = parseFloat(last).toFixed(2)

                        myChart.setOption({
                            /*title: {
                              text: '某站点用户访问来源',
                              subtext: '纯属虚构',
                              left: 'center'
                            },*/
                            tooltip: {
                                trigger: 'item',
                                formatter: '{b} : {c}GB ({d}%)'
                            },
                            legend: {
                                orient: 'vertical',
                                left: 'right',
                                data: ['已占用空间', '未占用空间']
                            },
                            series: [
                                {
                                    name: '访问来源',
                                    type: 'pie',
                                    radius: '55%',
                                    center: ['50%', '55%'],
                                    data: [
                                        {value: all, name: '已占用空间'},
                                        {value: last, name: '未占用空间'},
                                    ],
                                    emphasis: {
                                        itemStyle: {
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    }
                                }
                            ]
                        })
                        if (res.data.freeSpace / res.data.totalSpace < 0.1) {
                            console.log("free space too small")
                            this.$confirm("当前管理端服务器可用空间不足10%，可能会造成服务器宕机、云机数据丢失等异常，无法恢复，请尽快进行清理！", "服务器空间不足", {
                                confirmButtonText: "确认",
                                confirmButtonClass: "confirm-btn-red",
                                iconClass: "el-icon-c-red",
                                cancelButtonText: "取消",
                                showCancelButton: false
                            })
                                .then(() => {
                                })
                                .catch(() => {
                                });
                        }
                    }
                })
            },
            init() {
                this
                    .$post(this.$uri.device.deviceList, {
                        startPage: 1,
                        limit: 1
                    })
                    .then(res => {
                        if (res.success) {
                            this.deviceNum = res.total;
                        }
                    });

                this
                    .$post(this.$uri.device.deviceList, {
                        startPage: 1,
                        limit: 1,
                        deviceStatus: 3
                    })
                    .then(res => {
                        if (res.success) {
                            this.badNum = res.total;
                        }
                    });

                this
                    .$post(this.$uri.device.deviceList, {
                        startPage: 1,
                        limit: 1,
                        isFlow: 1
                    })
                    .then(res => {
                        if (res.success) {
                            this.streamNum = res.total;
                        }
                    });

                this.$post(this.$uri.device.deviceList, {deviceStatus: 3}).then(res => {
                    if (res.success) {
                        this.devList = res.list;
                    }
                });
            }
        },
        beforeCreate() {
            that = this;
        },
        beforeDestroy() {
            if (this.refreshChartsTimer) {
                // console.log("clearInterval")
                clearInterval(this.refreshChartsTimer)
            }
        },
        beforeMount() {

        },
        mounted() {
            // console.log("mounted 2222222222222222")
            this.latelyPages = this.$store.getters.latelyPages;
            this.normalPages = this.$store.getters.normalPages;
            this.getLicense()
            // console.log(this.normalPages);
            this.init()
            this.getDiskSpace();
            this.getArmSrvList();
            this.refreshChartsTimer = setInterval(that.getArmSrvList, 3000);
        }
    };
</script>

<style lang="less">

    #overview-container {
        background-color: #efefef;
        position: fixed;
        left: 220px;
        top: 50px;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        margin: 10px;
        padding: 10px;
    }

    #middle-area {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex-grow: 1;
    }

    .show-pic-area {
        width: 100%;
        height: 100%;
        background-color: rgba(192, 192, 192, 0.4);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        position: fixed;
        left: 0px;
        top: 0px;
    }

    #temp-area-show-pic {
        /*width:1355px;*/
        width: 903px;
        /*height: 762px;*/
        height: 508px;
        background: url(../assets/tempShowFor1U.png) no-repeat;
        background-size: cover;
    }

    #fan-area-show-pic {
        /*width:1355px;*/
        width: 903px;
        /*height: 762px;*/
        height: 508px;
        background: url(../assets/fanShowFor1U.png) no-repeat;
        background-size: cover;
        /*z-index: 9999;*/
    }

    #right-area {
        display: flex;
        flex-direction: column;
        margin-left: 15px;
    }

    .right-side-info {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: left;
        padding: 20px 20px 10px 20px;
        font-size: 14px;
    }

    .contact-text {
        text-align: left;
        margin-top: 10px;
    }

    .right-side-area {
        background-color: white;
        padding: 10px;
        height: 200px;
        margin-bottom: 15px;
    }

    #middle-top-area {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        width: 100%;
        max-height: 220px;
        /*background-color: red;*/
    }

    #middle-bottom-area {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        width: 100%;
        max-height: 460px;
        margin-top: 15px;
        /*margin-bottom: 15px;*/
    }

    .device-overview {
        background-color: white;
        padding: 10px;
        flex-grow: 1;
        /*width: 80%;*/
    }

    .title {
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #ddd;
        text-align: left;
        padding-bottom: 5px;
    }

    .temp-title {
        font-size: 14px;
        font-weight: 600;
        /*border-bottom: 1px solid #ddd;*/
        text-align: left;
        padding-bottom: 5px;
        margin-left: 10px;
        /*background-color: blue;*/
        height: 20px;
        /*width: 100%;*/
        line-height: 20px;
    }

    .fan-title {
        padding-bottom: 5px;
        margin-left: 10px;
        height: 20px;
        /*width: 100%;*/
        /*color: transparent;*/
        line-height: 20px;
        visibility: hidden;
        /*background-color: red;*/
    }

    #device-overview-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px 20px 0 20px;
        flex-grow: 1;
    }

    .device-info {
        width: 150px;
        height: 150px;
        background-color: #efefef;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .device-info-title {
            margin-bottom: 20px;
            font-size: 12px;
        }
        .device-info-info {
        }
    }

    .down-device-area {
        background-color: white;
        padding: 10px;
        margin-left: 15px;
        width: 380px;
    }

    #down-device-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 5px;
        padding: 5px 0px;
    }

    .down-device-text {
        text-align: left;
        font-size: 14px;
        width: 33%;
    }

    #down-device-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0 20px 0 20px;
        max-height: 120px;
        overflow-y: auto;
    }

    #down-device-list::-webkit-scrollbar {
        display: none;
    }

    #down-device {
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;
    }

    #useful-entry-list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 20px 20px 20px;
        font-size: 14px;
    }

    #recently-entry-list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 20px 20px 20px;
        font-size: 14px;
    }

    .node {
        margin-top: 15px;
        width: 100px;
        text-align: left;
        color: #409eff;
    }

    .node:hover {
        text-decoration: underline;
        cursor: pointer;
        color: #409eff;
    }

    .shadow {
        box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.2);
    }

    .server-info-area {
        margin-top: 15px;
        /*background-color: red;*/
        /*padding: 10px;*/
        display: flex;
        flex-direction: column;
        /*max-height: 340px;*/
        max-height: 342px;
        /*/deep/.el-scrollbar__wrap {*/
        /*overflow-x: hidden;*/
        /*}*/
    }

    .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .server-info-area::-webkit-scrollbar {
        display: none;
    }

    .server-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: white;
    }

    .server-info-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        width: 100%;
        height: 170px;
        background-color: white;
        /*border-bottom: 1px solid #d7d7d7;*/
    }

    .my-line {
        width: 96%;
        height: 1px;
        background-color: #d7d7d7;
    }

    .temp-show-area {
        width: 50%;
        height: 86%;
        border-right: 1px solid #ddd;
        display: flex;
        flex-direction: column;
        /*background-color: red;*/
    }

    .temp-tooltip {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 90px;
        /*height: 160px;*/
        line-height: 20px;
        /*background-color:white;*/
    }

    .fan-show-area {
        width: 50%;
        height: 86%;
        border-right: 1px solid #ddd;
        display: flex;
        flex-direction: column;
        /*background-color: #55a532;*/
    }

    .fan-tooltip {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100px;
        /*height: 160px;*/
        line-height: 20px;
        /*background-color:white;*/
    }

    .license-area {
        background-color: white;
        padding: 10px;
        max-height: 440px;
        flex-grow: 1;
    }

    .license-info {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: left;
        padding: 10px 20px 10px 20px;
        font-size: 14px;
        max-height: 360px;
        overflow-y: scroll;
    }

    ::-webkit-scrollbar {
        width: 0 !important;
    }
    .license-info-first-line {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: flex-start;
    }

    .license-info-text {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: flex-start;
        text-align: left;
        margin-top: 10px;
        font-size: 15px;
    }

    #license-service-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 430px;
    }

    .auth-online-help {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .disk-space {
        background-color: white;
        padding: 10px;
        margin-left: 15px;
        width: 380px;
        min-height: 300px;
    }

    .show-item-child {
        margin-left: 30px;
        font-size: 14px;
        width: 140px;
        padding: 3px 30px 3px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 16px;
        }
    }

    .temp-chart-area, .fan-chart-area {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        /*background-color: blue;*/
    }

    .temp-chart-show {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
        width: 50%;
        height: 100%;
        padding-right: 10%;
        /*background-color: #55a532;*/
    }

    .fan-chart-show {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
        width: 50%;
        height: 100%;
        padding-right: 10%;
        /*background-color: #55a532;*/
    }

    .temp-desc-area, .fan-desc-area {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        /*justify-content: space-between;*/
        /*background-color: #55a532;*/
    }

    .temp-desc-tips, .fan-desc-tips {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 50%;
        height: 20px;
    }

    .temp-desc-area > label {
        margin-top: 6px;
    }

    .fan-desc-area > label {
        margin-top: 6px;
    }

    .high-temp-area, .down-fan-area {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        line-height: 20px;
        text-align: left;
    }

    .question-icon {
        margin-left: 5px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        border-radius: 50%;
        background-color: grey;
        color: white;
        display: inline-block;
        position: relative;
    }

    .info-view-main {
        font-size: 12px;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: flex-start;
        .info-view-item {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 2px 0;
            height: 22px;
        }
        .info-view-item-list {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 2px 0;
            .service-item,.device-notforever-item  {
                display: flex;
                flex-direction: row;
                padding: 2px 0px 2px 20px;
                height: 20px;
                align-items: center;
                justify-content: center;
            }
        }
        .info-view-item-btn {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 5px 0;
        }
    }
</style>
